export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/money.23b0b306.svg","height":15,"width":12,"blurWidth":0,"blurHeight":0};